<footer>
  <p>
    Developed by{' '}
    <a
      href="https://www.linkedin.com/in/lcollares"
      target="_blank"
      rel="noopener noreferrer"
    >
      Leandro Collares
    </a>{' '}
    &middot; Source:{' '}
    <a
      href="https://www150.statcan.gc.ca/n1/pub/11-630-x/11-630-x2016006-eng.htm"
      target="_blank"
      rel="noopener noreferrer"
    >
      Statistics Canada
    </a>
  </p>
</footer>

<style>
  footer {
    margin-top: 5px;
    margin-bottom: 20px;
  }

  p {
    text-align: center;
  }

  a {
    outline: none;
    text-decoration: none;
  }

  a:visited {
    color: #4427ca;
  }

  a:active {
    color: #dc267f;
  }

  a:hover {
    color: #dc267f;
    border-bottom: 1px dotted;
  }
</style>
